import { createTheme } from "@mui/material/styles";

export const FTPTheme = createTheme({
  palette: {
    primary: {
      main: "#3A80F4",
      dark: "#2067D8",
      light: "#5D9AFF",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#F7433A",
      dark: "#DA1F1E",
      light: "#FF6F61",
    },
    success: {
      main: "#1DB954",
    },
    info: {
      main: "#3A80F4",
    },
    warning: {
      main: "#FFA726",
    },
    error: {
      main: "#F44336",
    },
    background: {
      default: "#ECEDEF",
    },
    text: {
      primary: "#1B1B1D",
    },
    grey: {
      100: "#ECEDEF",
      200: "#E0E0E0",
      300: "#DBDBDB",
      400: "#B6B6B6",
      500: "#959595",
    },
    common: {
      white: "#FFFFFF",
      black: "#1B1B1D",
    },
  },
  shape: {
    borderRadius: 8,
  },
  typography: {
    fontFamily: "WorkSans",
    fontSize: 14,
    h1: { fontSize: "2rem", fontWeight: 600, lineHeight: 1.2 },
    h2: { fontSize: "1.6rem", fontWeight: 500, lineHeight: 1.25 },
    h3: { fontSize: "1.35rem", fontWeight: 500, lineHeight: 1.3 },
    h4: { fontSize: "1.15rem", fontWeight: 500, lineHeight: 1.3 },
    h5: { fontSize: "1rem", fontWeight: 600, lineHeight: 1.35 },
    h6: { fontSize: "0.95rem", fontWeight: 600, lineHeight: 1.35 },
    subtitle1: { fontSize: "0.95rem", fontWeight: 400, lineHeight: 1.45 },
    subtitle2: { fontSize: "0.85rem", fontWeight: 400, lineHeight: 1.45 },
    body1: { fontSize: "0.95rem", fontWeight: 400, lineHeight: 1.5 },
    body2: { fontSize: "0.85rem", fontWeight: 400, lineHeight: 1.5 },
    button: { fontSize: "0.95rem", fontWeight: 500, textTransform: "none", lineHeight: 1.4 },
    caption: { fontSize: "0.75rem", fontWeight: 400, lineHeight: 1.4 },
    overline: { fontSize: "0.75rem", fontWeight: 400, lineHeight: 1.4 },
  },
  components: {
    MuiInput: {
      styleOverrides: {
        input: { fontFamily: "WorkSans" },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: { fontSize: "0.95rem" },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: { borderRadius: 8, fontSize: "0.95rem" },
        input: { padding: "9px 12px" },
      },
    },
    MuiTextField: {
      defaultProps: { size: "small" },
    },
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 8, padding: "8px 14px" },
        sizeSmall: { padding: "6px 10px" },
        sizeMedium: { padding: "8px 14px" },
        sizeLarge: { padding: "10px 18px" },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { borderRadius: 8, fontSize: "0.8rem", height: 26, padding: "0 6px" },
        label: { paddingLeft: 6, paddingRight: 6 },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: { padding: "8px 12px", fontSize: "0.95rem" },
        sizeSmall: { padding: "6px 10px" },
      },
    },
    MuiMenuItem: {
      styleOverrides: { root: { paddingTop: 6, paddingBottom: 6, fontSize: "0.95rem" } },
    },
  },
});
